module.exports = __webpack_public_path__ + "media/images/webpage/hotels/theme/icon-hotel-88c0be54f8cab3c9fee066671f661bdf.webp";